import { RETAIL } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { getIsRetail } from 'pricing-pages-lib/api/RetailApi';
export const FetchRetailRequestTypes = createRequestTypes(RETAIL);
export const FetchRetailActions = createRequestActions(FetchRetailRequestTypes);
export const fetchIsRetail = () => makeFetchRequest({
  requestActions: FetchRetailActions,
  fetch: getIsRetail
});